<template>
  <div class="MyTesting-box" style="background-color: #f8f8f8">
    <nav>
      <!-- <router-link
        to="/"
        class="item"
      >
        我要检测
      </router-link> -->
      <router-link to="/MyTesting" class="item active"> 我的报告 </router-link>
      <div
        class="multipleChoice"
        @click="multipleChoiceFun"
        v-if="!multipleChoiceFlag"
      >
        批量绑定
      </div>
      <div class="save" v-if="multipleChoiceFlag" @click="goSweepCodeBinding2">
        保存
      </div>
      <div class="no" v-if="multipleChoiceFlag" @click="multipleChoiceFun">
        取消
      </div>
    </nav>
    <div
      class="myTestingList"
      id="myTestingList"
      v-if="myTestingList.length > 0"
    >
      <div
        class="item"
        v-for="(item, index) in myTestingList"
        :key="index"
        v-if="myTestingFlag"
      >
        <div class="top">
          <div class="name">
            {{ item.productName }}
          </div>
          <div class="time">{{ item.createTime | evaluateTime }}</div>
        </div>
        <div class="center">
          条码号：{{ item.barCode }}
          <div
            :class="{
              select: true,
              active: multipleChoiceArr.includes(item.subOrderNo),
            }"
            v-if="multipleChoiceFlag && item.status == 0"
            @click="addMultipleChoice(item.subOrderNo, item.status)"
          >
            {{
              multipleChoiceArr.includes(item.subOrderNo)
                ? "点击取消选中"
                : "点击选中"
            }}
          </div>
        </div>
        <div class="bottom">
          <div class="order-start">状态：{{ item.statusTxt }}</div>
          <div
            class="seePresentation"
            v-if="item.status == 0"
            @click="goSweepCodeBinding(item.subOrderNo)"
          >
            绑定检测管
          </div>
          <div
            class="seePresentation"
            v-if="item.reportStatus == 2 && item.status == 4"
            @click="goSeePresentation(item)"
          >
            查看报告
          </div>
        </div>
      </div>
    </div>
    <div
      class="noTestingList"
      :style="{ height: clientHeight - 130 + 'px' }"
      v-else-if="myTestingFlag && myTestingList.length == 0"
    >
      <div class="noTestingListContent">
        <img src="../../assets/images/updataFile/noTestingList-icon.png" />
        <div class="txt">抱歉，未查询到任何报告</div>
      </div>
    </div>
    <div class="pdfUrlsPopup" v-if="pdfUrlsPopupFlag">
      <div class="pdfUrlsMask"></div>
      <div class="pdfUrlsContent">
        <div class="title">
          选择报告

          <img
            src="../../assets/images/updataFile/shutIcon.png"
            class="shut"
            @click="pdfUrlsPopupFlag = false"
          />
        </div>
        <div class="pdfUrlsList">
          <div
            class="pdfUrlsItem"
            v-for="(item, index) in pdfUrls"
            :key="index"
            @click="openPdfUrlsItem(item.url)"
          >
           {{item.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {
      myTestingFlag: false,
      userInfo: {},
      paging: {
        userId: 0,
        size: 10,
        current: 1,
      },
      total: 0,
      myTestingList: [],
      scrollLoadMoreFlag: true,
      multipleChoiceFlag: false,
      multipleChoiceArr: [],
      pdfUrlsPopupFlag: false,
      pdfUrls: [],
    };
  },
  created() {
    if (localStorage.getItem("userInfo")) {
      localStorage.removeItem("multipleChoiceArr");
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      localStorage.removeItem("bindingUserInfoList");

      this.paging.userId = this.userInfo.id;
      // this.paging.userId = "1631204042287878145";
      this.getMyTesting();
      window.addEventListener("scroll", this.scrollLoadMore);
      this.clientHeight = document.body.clientHeight;
      if (!this.$store.state.wxConfigFlag) this.$wxConfig();
    } else this.$goLogin();
  },
  methods: {
    multipleChoiceFun() {
      this.multipleChoiceFlag = !this.multipleChoiceFlag;
      if (!this.multipleChoiceFlag) {
        this.multipleChoiceArr = [];
      }
    },
    addMultipleChoice(subOrderNo, status) {
      if (status == 0) {
        if (this.multipleChoiceArr.includes(subOrderNo)) {
          this.multipleChoiceArr.splice(
            this.multipleChoiceArr.indexOf(subOrderNo),
            1
          );
        } else this.multipleChoiceArr.push(subOrderNo);
        console.log(this.multipleChoiceArr);
      }
    },
    /**
     * 判断是安卓还是ios
     */
    isIOS() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return false;
      }
      if (isIOS) {
        return true;
      }
    },
    /**
     * 根据订单号跳转到查看报告页
     */
    goSeePresentation(item) {
      if (item.pdfUrls && item.pdfUrls.length > 1) {
        this.pdfUrlsPopupFlag = true;
        let list = item.pdfUrls;
        let arr = [];
        list.forEach((item) => {
          let itemarr = item.split("/");
          let name = itemarr[itemarr.length - 1];
          arr.push({ name, url: item });
        });
        this.pdfUrls = arr;
      } else if (item.pdfUrl) {
        if (this.isIOS()) {
          location.href = item.pdfUrl;
        } else {
          this.$router.push({
            name: "SeePresentation",
            query: { pdfUrl: item.pdfUrl },
          });
        }
      } else this.$toots("该订单还未生成报告，请稍后查看");
    },
    openPdfUrlsItem(pdfUrl) {
      if (this.isIOS()) {
        location.href = pdfUrl;
      } else {
        this.$router.push({
          name: "SeePresentation",
          query: { pdfUrl: pdfUrl },
        });
      }
    },
    /**
     * 获取有已完成的订单
     */
    getMyTesting(flag) {
      this.$loading();
      this.$http
        .get(`/userOrder/getUserOrderPageByUserId`, {
          params: this.paging,
        })
        .then((res) => {
          this.$store.state.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let list = data.records;
              let arr = this.myTestingList;
              if (flag) arr = [];
              let statusArr = [
                "待绑定",
                "待回寄",
                "待检测",
                "检测中",
                "已完成",
                "不合格，重新取样中",
              ];
              for (let i = 0; i < list.length; i++) {
                //  1-待寄回；  2-待检测；  3-检测中；  4-已完成；  5.不合格，重新取样中 ；  6-已取消
                list[i].statusTxt = statusArr[list[i].status];
                if (list[i].pdfUrls && list[i].pdfUrls.length > 0) {
                  list[i].pdfUrl = list[i].pdfUrls[0];
                }
                arr.push(list[i]);
              }
              this.total = data.total;
              this.scrollLoadMoreFlag = true;
              this.myTestingFlag = true;
              this.myTestingList = arr;
            }
          }
        })
        .catch((err) => {
          this.myTestingFlag = true;
          this.$toots("系统正在升级，请稍后");
        });
    },
    /**
     * 滚动到底部加载更多
     */
    scrollLoadMore() {
      let size = this.paging.current * this.paging.size;
      if (this.scrollLoadMoreFlag && this.total > size) {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop; // 兼容获取滚动条高度
        var scrollHeight =
          document.getElementById("myTestingList").scrollHeight; // 获取整个document的高度
        var clientHeight = document.body.clientHeight; //获取当前显示的高度
        if (clientHeight + scrollTop + 30 > scrollHeight) {
          this.scrollLoadMoreFlag = false;
          this.paging.current = this.paging.current + 1;
          this.getMyTesting();
        }
      }
    },
    goSweepCodeBinding(subOrderNo) {
      this.$router.push({
        name: "sweepCodeBinding",
        query: {
          subOrderNo: subOrderNo,
        },
      });
    },
    goSweepCodeBinding2() {
      if (this.multipleChoiceArr.length > 0) {
        localStorage.setItem(
          "multipleChoiceArr",
          JSON.stringify(this.multipleChoiceArr)
        );
        this.$router.push({
          name: "sweepCodeBinding",
        });
      } else this.$toots("请选择要绑定的项目");
    },
  },
  /**
   * 该组件卸载时，移除scrollToTop事件
   */
  destroyed() {
    window.removeEventListener("scroll", this.scrollLoadMore, false);
  },
};
</script>
<style lang="less" scoped>
.pdfUrlsPopup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  .pdfUrlsMask {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .pdfUrlsContent {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #fff;
    line-height: 80px;
    font-size: 26px;
    text-align: center;
    .title {
      font-weight: 700;
      font-size: 30px;
      position: relative;
      .shut {
        position: absolute;
        top: 50%;
        right: 30px;
        transform: translateY(-50%);
        width: 30px;
        height: 30px;
      }
    }
  }
}
.myTestingList {
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 20px;
  .item:first-child {
    margin-top: -134px;
  }
  .item {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 46px;
    background-color: #fff;
    border-radius: 20px;
    margin-bottom: 20px;
    box-shadow: 0 0 30px 0px rgba(193, 191, 191, 0.5);
    .top {
      display: flex;
      justify-content: space-between;
      .name {
        font-size: 34px;
        font-weight: 700;
        text-align: justify;
      }
      .time {
        font-size: 24px;
        color: #cccccc;
        margin-top: 4px;
        padding-left: 40px;
      }
    }
    .center {
      color: #999999;
      font-size: 26px;
      padding-top: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;
      position: relative;
      .select.active {
        color: #1968a8;
      }
      .select {
        position: absolute;
        top: 50%;
        right: 0px;
        transform: translateY(-50%);
      }
    }
    .bottom {
      height: 96px;
      line-height: 96px;
      display: flex;
      justify-content: space-between;
      font-size: 26px;
      .seePresentation {
        margin-top: 16px;
        padding-left: 30px;
        padding-right: 30px;
        height: 54px;
        line-height: 54px;
        color: #1968a8;
        border-radius: 54px;
        border: 1px solid #1968a8;
      }
    }
  }
}
.noTestingList {
  width: 690px;
  margin: 0 auto;
  margin-top: -134px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 30px 0px rgba(193, 191, 191, 0.5);
  .noTestingListContent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  img {
    width: 374px;
    height: 288px;
    display: block;
    margin: 0 auto;
  }
  .txt {
    font-size: 28px;
    line-height: 38px;
    color: #999999;
    text-align: center;
  }
}
</style>

